module.exports = __webpack_public_path__ + "img/pc-bg03.2e0b3b05.png";